import { useState, useEffect } from 'react'
import { ArrowDown } from 'lucide-react'
import { useTranslation } from '@/hooks/useTranslation'

const PreviewArrow = () => {
  const { t } = useTranslation()
  const [shouldBounce, setShouldBounce] = useState(false)
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    // Trigger bounce animation after component mounts
    const bounceTimer = setTimeout(() => {
      setShouldBounce(true)
      // Remove bounce class after animation completes (2 bounces = ~1.2s)
      setTimeout(() => setShouldBounce(false), 1200)
    }, 500)

    // Hide the arrow after 6 seconds
    const hideTimer = setTimeout(() => {
      setIsVisible(false)
    }, 3000)

    return () => {
      clearTimeout(bounceTimer)
      clearTimeout(hideTimer)
    }
  }, [])

  if (!isVisible) return null

  return (
    <div className={`fixed bottom-16 right-8 z-50 pointer-events-none ${shouldBounce ? 'animate-nudge' : ''}`}>
      {/* Text bubble with arrow attached */}
      <div className="relative">
        <div className="bg-white rounded-lg shadow-lg border border-gray-200 px-4 py-2 relative mb-1 w-32">
          <div className="text-sm font-medium text-gray-800 text-center">
            {t('previewArrow.preview')}
          </div>
        </div>
        
        {/* Arrow icon positioned right below the bubble */}
        <div className="flex justify-end">
          <ArrowDown 
            className="text-primary drop-shadow-lg" 
            size={32}
          />
        </div>
      </div>
    </div>
  )
}

export default PreviewArrow 